(() => {
  'use strict';

  const previewKeys = ['preview_theme_id', '_fd', 'pb'];
  const initialUrl = new URL(window.location.href);
  const previewParams = new URLSearchParams();

  previewKeys.forEach((key) => {
    const value = initialUrl.searchParams.get(key);
    if (value) previewParams.set(key, value);
  });

  if (![...previewParams.keys()].length) return;

  const appendPreviewParams = (value) => {
    try {
      const nextUrl = new URL(value, window.location.origin);
      previewParams.forEach((paramValue, key) => {
        nextUrl.searchParams.set(key, paramValue);
      });
      return `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`;
    } catch (error) {
      return value;
    }
  };

  customElements.whenDefined('product-info').then(() => {
    const ProductInfo = customElements.get('product-info');
    const proto = ProductInfo?.prototype;
    if (!proto || proto.__gdcPreviewRequestPatchedV2) return;

    const originalBuildRequestUrlWithParams = proto.buildRequestUrlWithParams;
    const originalUpdateURL = proto.updateURL;

    if (typeof originalBuildRequestUrlWithParams === 'function') {
      proto.buildRequestUrlWithParams = function (...args) {
        const builtUrl = originalBuildRequestUrlWithParams.apply(this, args);
        return appendPreviewParams(builtUrl);
      };
    }

    if (typeof originalUpdateURL === 'function') {
      proto.updateURL = function (url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;

        const targetUrl = appendPreviewParams(
          `${url}${variantId ? `?variant=${variantId}` : ''}`
        );
        window.history.replaceState({}, '', targetUrl);
      };
    }

    proto.__gdcPreviewRequestPatchedV2 = true;
  });
})();
